/** PURE_IMPORTS_START .._.._Observable,.._.._operator_elementAt PURE_IMPORTS_END */
import { Observable } from '../../Observable';
import { elementAt } from '../../operator/elementAt';
Observable.prototype.elementAt = elementAt;
//# sourceMappingURL=elementAt.js.map 



//////////////////
// WEBPACK FOOTER
// ./~/rxjs/_esm5/add/operator/elementAt.js
// module id = 666
// module chunks = 0